var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.824,
    height: 21.828,
    viewBox: "0 0 23.824 21.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-504.88 -150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Frame",
    d: "M506.349,185a1.469,1.469,0,0,0-1.469,1.469V201.04a1.469,1.469,0,0,0,1.469,1.469h.711v-1.2H506.3a.268.268,0,0,1-.267-.267V186.47a.268.268,0,0,1,.267-.267h1.971v-.44a4.072,4.072,0,0,1,.075-.762Zm20.885,0h-1.983a3.177,3.177,0,0,1,.044.5v.7h1.987a.267.267,0,0,1,.267.267v14.568a.267.267,0,0,1-.267.267h-.777v1.2h.728a1.469,1.469,0,0,0,1.47-1.469V186.469A1.469,1.469,0,0,0,527.234,185Z",
    transform: "translate(0 -32.661)",
    fill: "var(--theme-text)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M590.883,171.826a.152.152,0,0,1-.043,0h-2.978a.156.156,0,0,1-.176-.132.152.152,0,0,1,0-.043V153.542h-2.1l0,14.9v3.281c0,.068-.058.1-.175.1H582.43c-.117,0-.176-.034-.176-.1V153.542h-2.1v18.109a.155.155,0,0,1-.133.175.152.152,0,0,1-.043,0H577a.156.156,0,0,1-.176-.132.179.179,0,0,1,0-.043V153.236a3.493,3.493,0,0,1,.123-.9A2.942,2.942,0,0,1,579.863,150h7.926a2.957,2.957,0,0,1,3.137,2.339,2.988,2.988,0,0,1,.089.677v18.635A.155.155,0,0,1,590.883,171.826Z",
    transform: "translate(-67.138)",
    fill: "var(--theme-text)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.15e9c760196e8e74be10d1fae09e037e.svg";
export { ForwardRef as ReactComponent };